import states from "../../../data/states.json";

import useTableActions from "../../../hooks/use-table-actions";
import useRemoteActionProps from "../../../hooks/use-remote-action-props";

import Base from "../../base";

import ContentCard from "../../../components/content-card";
import ActionTable from "../../../components/action-table";

import { ColumnCell } from "../../../types/data-table";

const COLUMNS: ColumnCell[] = [
	{
		name: "state",
		type: "choice",
		title: "State",
		accessor: "state",
		index: "lexical",
		fit: "shrink",
		editable: true,
		config: {
			options: states,
			labelAccessor: "state",
			valueAccessor: "state"
		}
	},
	{
		name: "callLetters",
		title: "Call Letters",
		accessor: "call_letters",
		editable: true
	},
	{
		name: "affiliation",
		title: "Affiliation",
		accessor: "affiliation",
		editable: true
	},
	{
		name: "market",
		title: "Market",
		accessor: "market",
		editable: true
	},
	{
		name: "identifier",
		title: "Identifier",
		accessor: "identifier",
		editable: true
	},
	{
		name: "created",
		type: "date-time",
		title: "Candidate",
		accessor: "created",
	}
];

const Cable = () => {
	const actions = useTableActions({
		addLabel: "Add Cable Station",
		add: () => ({
			state: "US",
			call_letters: "",
			affiliation: "",
			market: "",
			identifier: "",
			created: Math.round(Date.now() / 1000)
		}),
		createEach: row => {
			console.log("CREATE");
		},
		modifyEach: row => {
			console.log("MODIFY");
		},
		deleteEach: row => {
			console.log("DELETE");
		}
	});

	const props = useRemoteActionProps({
		request: "/stations/cable/list",
		columns: COLUMNS,
		pageSize: 50,
		actions,
		expand: true
	});

	return (
		<Base limited>
			<ContentCard>
				<ActionTable {...props} />
			</ContentCard>
		</Base>
	);
};

export default Cable;
